export default __webpack_public_path__ + "static/media/email.a1d661fb.png";